import React from 'react'
import { Link } from 'react-router-dom'
import ShapeAnimation from '../../../ShapeAnimation'
const BluetoothBanner = () => {
    return (
        <>
            <div className="portfolio-banner4">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">
                            {/*      <h2 class="banner-heading">Portfolio</h2> */}
                        </div>
                    </div>
                </div>
                <ShapeAnimation/>
            </div>

            <div className="bread-internal-cls">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/services">Services</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Bluetooth
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default BluetoothBanner